import { useEffect } from "react";
import "lenis/dist/lenis.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { startLenis, scrollToId } from "@/components/site/lenis";
import PrivacyPage from "@/pages/PrivacyPage";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { About } from "@/components/site/About";

const Home = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 400);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <>
      <Hero />
      <Marquee />
      <Services />
      <Contact />
      <About />
    </>
  );
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    return startLenis();
  }, []);

  return (
    <BrowserRouter>
    <div className="grain min-h-screen bg-[#121A23] text-[#FAF6ED] font-body">
      <a href="#services" className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[60] focus:bg-[#B59A5B] focus:text-[#131B24] focus:px-4 focus:py-2 rounded" data-testid="skip-link">
        Skip to services
      </a>
      <Nav />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
    </BrowserRouter>
  );
}

export default App;
